import styled from 'styled-components'
import { Icon as AntIcon, Spin as AntSpin } from 'antd'

import AntTitle from 'antd/lib/typography/Title'

export const Content = styled.div`
  margin: 8px 16px 24px 16px;
`

export const Empty = styled.div`
  align-items: center;
  background-color: #fafafa;
  border-bottom: 0;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  color: rgba(0, 0, 0, 0.65);
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  padding: 1.5rem;
`

export const Icon = styled(AntIcon)`
  font-size: large;
`

export const ReasonActive = styled.div`
  align-content: center;
  align-items: center;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  width: 5rem;
`

export const RuleButtonNew = styled.div`
  margin: 1rem;
  text-align: right;
`

export const Spin = styled(AntSpin)`
  margin-top: 1rem;
`

export const Title = styled(AntTitle)`
  padding-right: 0.5rem;
`

export const TitleContent = styled.div`
  display: flex;
  margin: 2rem 0 1rem 0;
`
